import FormControlLabel from "@mui/material/FormControlLabel";
import { Checkbox } from "@mui/material";

const CustomCheckbox = (props) => {

    return(
        <FormControlLabel
        disabled = {props.disabled}
            control={
                <Checkbox
                    checked={props.checked}
                    indeterminate={props.indeterminate}
                    onChange={props.onChange}
                    name={props.name}
                    sx={{
                        color: props.theme.Coco,
                        padding: 0,
                        paddingRight: 1,
                        '&.Mui-checked': {
                            color: props.theme.Magenta,
                        },
                        '&.MuiCheckbox-indeterminate': {
                            color: props.theme.Magenta,
                        },
                        ...props.sx
                    }}
                />
            }
            label={props.textLabel}
            onClick={props.onClick}
            onMouseEnter={props.onMouseEnter}
            onMouseLeave={props.onMouseLeave}
            sx={{
                '& .MuiTypography-root': {
                    color: props.checked || props.indeterminate ? props.theme.Magenta : props.theme.Coco,
                    size: 15
                },
                '&:hover' : {
                    '& .MuiCheckbox-root': {
                        color: props.checked ? props.theme.Magenta : props.theme.Lao
                    },
                    '& .MuiTypography-root': {
                        color: props.checked ? props.theme.Magenta : props.theme.Lao
                    }
                },

                ...props.sx
            }}
        />
    );
}

export default CustomCheckbox;